package ru.villawonka.app.data.entity.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.CountryDomain
import ru.villawonka.app.domain.model.CurrencyDomain
import ru.villawonka.app.domain.model.LanguageDomain
import ru.villawonka.app.domain.model.UserSettingsDomain

@Serializable
data class UserSettingsResponse(
    @SerialName("country")
    val country: String?,
    @SerialName("currency")
    val currency: String?,
    @SerialName("language")
    val language: String?,
)

fun UserSettingsResponse.toDomain() = UserSettingsDomain(
    country = when (country) {
        "ID" -> CountryDomain.INDONESIA
        "TH" -> CountryDomain.THAILAND
        "VN" -> CountryDomain.VIETNAM
        else -> CountryDomain.INDONESIA
    },
    currency = when (currency) {
        "IDR" -> CurrencyDomain.IDR
        "USD" -> CurrencyDomain.USD
        "RUB" -> CurrencyDomain.RUB
        "CNY" -> CurrencyDomain.CNY
        else -> CurrencyDomain.USD
    },
    language = when (language) {
        "en" -> LanguageDomain.EN
        "ru" -> LanguageDomain.RU
        else -> LanguageDomain.EN
    },
)